import React from 'react';
import PropTypes from 'prop-types';

import InputItem from '../../../../../../components/form/inputitem';
import SelectArrayItem from '../../../../../../components/form/selectarrayitem';
import ModalFooter from '../../../../../../components/modalfooter';

class VariableForm extends React.PureComponent {
    render() {
        const { variable, onChangeName, onChangeValidator, onClickAddOption, onClickDeleteOption, loading, button_cancel_text, button_ok_text, handleCancelClick, handleOkClick } = this.props;
        return (
            <div className="ori-b-pad-10">
                <InputItem title="name" placeholder="Enter variable name" value={variable.name} onChange={onChangeName} />
                <InputItem title="validator" placeholder="Enter regular expression" value={variable.validator} onChange={onChangeValidator} />
                <SelectArrayItem title="options" input_type="input" type="string" select_placeholder="Enter new option" add_btn_text="Add New Option" array={variable.options} onClickAdd={onClickAddOption} onClickDelete={onClickDeleteOption} />
                <div className="ori-absolute ori-full-width ori-align-bottom ori-b-pad-5 ori-align-left">
                    <ModalFooter loading={loading} button_cancel_text={button_cancel_text} button_ok_text={button_ok_text} handleCancelClick={handleCancelClick} handleOkClick={handleOkClick} capsule_button />
                </div>
            </div>
        );
    }
}

VariableForm.propTypes = {
    variable: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    onChangeName: PropTypes.func,
    onChangeValidator: PropTypes.func,
    onClickAddOption: PropTypes.func,
    onClickDeleteOption: PropTypes.func,
    button_cancel_text: PropTypes.string,
    button_ok_text: PropTypes.string,
    handleCancelClick: PropTypes.func,
    handleOkClick: PropTypes.func,
};

VariableForm.defaultProps = {
    variable: {}
};

export default VariableForm;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/botparams/variableform/index.js